import ReactDOM from 'react-dom'

interface MarkerType {
  center: any
  map: google.maps.Map
  parentNode: any
  panes?: any
  setCenter?: any
}

const Circle: google.maps.OverlayView & {
  new (params: { map: google.maps.Map; center?: any }): MarkerType & google.maps.OverlayView
} = function(this: MarkerType & google.maps.OverlayView, params: any): void {
  this.setMap(params.map)
  this.center = params.center

  this.draw = function() {
    const { location, map, component } = params

    // Position the overlay
    const projection = this.getProjection()
    const point = projection.fromLatLngToDivPixel(this.center)

    if (this.parentNode) {
    }

    const test = this.parentNode.getBoundingClientRect()
    if (point) {
      this.parentNode.style.left = point.x - test.width / 2 + 'px'
      this.parentNode.style.top = point.y - test.width / 2 + 'px'
      this.parentNode.style.height = `${test.width}px`
      // this.parentNode.style.transition = '.5s ease all'
    }
  }

  this.setCenter = function(center: any) {
    this.center = center
  }

  this.onAdd = function() {
    const { location, map, component } = params

    this.parentNode = document.createElement('div')
    this.parentNode.style.position = 'absolute'
    this.parentNode.style.width = '100%'
    this.parentNode.style.borderRadius = '50%'
    this.parentNode.style.background = 'rgb(0,0,0,0.2)'
    // this.parentNode.style.transition = '.1s ease all'

    const panes: any = this.getPanes()
    if (this.parentNode && panes) {
      panes.overlayImage.appendChild(this.parentNode)
    }
  }

  this.onRemove = function() {
    if (this.parentNode && this.parentNode.parentNode) {
      this.parentNode.parentNode.removeChild(this.parentNode)
    }
  }
} as any

export default Circle
